const { coreappIpc } = window;

export const startNexonlink = (nexonsn: string, options?: any): Promise<boolean> => {
    return coreappIpc.send('startNexonlink', nexonsn, options || null);
}

export const stopNexonlink = () => {
    coreappIpc.send('stopNexonlink');
}

export const isNexonlinkStreaming = (gid: string): Promise<boolean> => {
    return coreappIpc.send('isNexonlinkStreaming', gid);
}
